import MenuBar from 'automation-ui-canvas/components/flow-header/menu-bar/MenuBar';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useCallback, useMemo } from 'react';
import { useHelpSearchOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/HelpSearchOption';
import { MetricsOption, PerformanceOption, VersionHistoryOption, useEnrollmentHistoryOption, useZoomOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/viewOptions';
import I18n from 'I18n';
import { ReviewFileOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/fileOptions';
import { RevisionHelpOption } from 'automation-ui-canvas/components/flow-header/menu-bar/menuOptions/helpOptions';
import { aggregateOptionsById, flattenOptionsToList, getAllShortcutOptions } from 'automation-ui-canvas/components/flow-header/menu-bar/utils/menuItemUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const FlowViewDefaultMenuBar = ({
  flow,
  canvasScrollElementRef
}) => {
  const ZoomOption = useZoomOption({
    flow
  });
  const EnrollmentHistoryOption = useEnrollmentHistoryOption({
    flow
  });
  const ViewSubOptions = useMemo(() => [[ZoomOption], [VersionHistoryOption, PerformanceOption, EnrollmentHistoryOption, MetricsOption]], [ZoomOption, EnrollmentHistoryOption]);
  const ViewOption = useMemo(() => ({
    id: 'view',
    getLabel: () => I18n.text('automation.editorMenuBar.menus.view'),
    options: ViewSubOptions
  }), [ViewSubOptions]);
  const HelpSearchOption = useHelpSearchOption();
  const TopLevelMenuOptions = useMemo(() => [ReviewFileOption, ViewOption, RevisionHelpOption], [ViewOption]);
  const AllMenuOptionsById = useMemo(() => aggregateOptionsById(TopLevelMenuOptions), [TopLevelMenuOptions]);
  const AllMenuOptionsList = useMemo(() => {
    return flattenOptionsToList(TopLevelMenuOptions).push(HelpSearchOption);
  }, [TopLevelMenuOptions, HelpSearchOption]);
  const AllShortcutOptions = getAllShortcutOptions(AllMenuOptionsList);
  const trackMenuOptionClick = useCallback((option, options) => {
    const isShortcut = options && options.isShortcut;
    trackEvent(Trackables.SELECTED_MENU_BAR_OPTION, {
      value: option.id,
      interactionType: isShortcut ? 'shortcut' : 'menu',
      mode: 'flow-view',
      type: 'dropdown'
    });
  }, []);
  return /*#__PURE__*/_jsx(MenuBar, {
    flow: flow,
    canvasScrollElementRef: canvasScrollElementRef,
    allMenuOptionsById: AllMenuOptionsById,
    topLevelMenuOptions: TopLevelMenuOptions,
    shortcutOptions: AllShortcutOptions,
    onMenuOptionClick: trackMenuOptionClick
  });
};
export default FlowViewDefaultMenuBar;